import { render, staticRenderFns } from "./imgUploadOne.vue?vue&type=template&id=1645cf68&scoped=true&"
import script from "./imgUploadOne.vue?vue&type=script&lang=js&"
export * from "./imgUploadOne.vue?vue&type=script&lang=js&"
import style0 from "./imgUploadOne.vue?vue&type=style&index=0&id=1645cf68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645cf68",
  null
  
)

export default component.exports